<div class="agpr-formField agpr-linkStyleField-container">
    <div class="agpr-formField-heading">
        <span class="agpr-formField-headingLabel">
            {{ field.label | localize }}
        </span>
        <span class="agpr-formField-headingButtons">
            @if(field.allowExpertMode) {
                <agpr-button
                    class="agpr-formField-headingButton"
                    [style]="buttonTypes.icon"
                    icon="fa-regular fa-duotone fa-code"
                    tooltip="PageBuilder.formField.tooltip.expertTemplateEditor"
                    tooltipPosition="top"
                    (click)="saveExpertTemplate()"
                ></agpr-button>
            }
            <agpr-button
                class="agpr-formField-headingButton"
                [style]="buttonTypes.icon"
                icon="fa-regular fa-duotone fa-floppy-disk"
                tooltip="PageBuilder.formField.tooltip.saveStyle"
                tooltipPosition="top"
                (click)="saveStyle()"
            ></agpr-button>
        </span>
    </div>
    <div class="agpr-formField agpr-linkStyleField-content">
        <div class="agpr-linkStyleField-styleState">
            <div>
                <div class="agpr-inputGroupRow">
                    <div class="agpr-inputGroupRow-dropdown">
                        <agpr-dropdown-field
                            [id]="id + '.styleStateDropdown'"
                            [value]="value.displayStyleState"
                            [field]="styleStateField"
                            (changes)="setStyle($event, styleStateField.property)"
                        >
                        </agpr-dropdown-field>
                    </div>
                    <div class="agpr-inputGroupRow-buttons">
                        <agpr-button
                            icon="fa-regular fa-duotone fa-gear"
                            [id]="id + '.manageStyles'"
                            [style]="buttonTypes.block"
                            [tooltip]="'PageBuilder.formField.tooltip.manageStyles' | localize"
                            (click)="manageStylesButtonClicked()"
                        >
                        </agpr-button>
                    </div>
                </div>
            </div>
        </div>
        <div
            *ngIf="!value.template"
        >
            <div
                role="group"
                [attr.aria-label]="'PageBuilder.formField.styles.display' | localize"
            >
                <div class="agpr-linkStyleField-header" [class.agpr-linkStyleField-header--textPrimary]="textPrimaryLabel">{{ 'PageBuilder.formField.styles.display' | localize }}</div>
                <agpr-dropdown-field
                    class="agpr-linkStyleField-displayDropdown"
                    [id]="id + '.displayDropdown'"
                    [value]="value.displayOption"
                    [field]="displayDropDownField"
                    (changes)="setStyle($event, 'displayOption')"
                >
                </agpr-dropdown-field>
                <div class="agpr-linkStyleField-row">
                    <div class="agpr-linkStyleField-radioRow">
                        <div role="radiogroup" [attr.aria-label]="'PageBuilder.formField.tooltip.linkAlignment' | localize" style="display: flex;">
                            <agpr-radio
                                class="agpr-linkStyleField-button"
                                [id]="id + '.leftRadioButton'"
                                name="alignment-{{id}}"
                                [value]="fontAlignmentEnum.left"
                                [(ngModel)]="value.alignment"
                                [iconTooltip]="'PageBuilder.formField.tooltip.alignLeft'"
                                tooltipPosition="top"
                                [style]="radioTypesEnum.button"
                                [icon]="'fa-objects-align-left'"
                                (onClick)="setStyle(fontAlignmentEnum.left, 'alignment')"
                                [hiddenLabel]="'PageBuilder.formField.tooltip.alignLeft' | localize"
                            ></agpr-radio>
                            <agpr-radio
                                class="agpr-linkStyleField-button"
                                [id]="id + '.centerRadioButton'"
                                name="alignment-{{id}}"
                                [value]="fontAlignmentEnum.center"
                                [(ngModel)]="value.alignment"
                                [iconTooltip]="'PageBuilder.formField.tooltip.alignCenter'"
                                tooltipPosition="top"
                                [style]="radioTypesEnum.button"
                                [icon]="'fa-objects-align-center-horizontal'"
                                (onClick)="setStyle(fontAlignmentEnum.center, 'alignment')"
                                [hiddenLabel]="'PageBuilder.formField.tooltip.alignCenter' | localize"
                            ></agpr-radio>
                            <agpr-radio
                                class="agpr-linkStyleField-button"
                                [id]="id + '.rightRadioButton'"
                                name="alignment-{{id}}"
                                [value]="fontAlignmentEnum.right"
                                [(ngModel)]="value.alignment"
                                [iconTooltip]="'PageBuilder.formField.tooltip.alignRight'"
                                tooltipPosition="top"
                                [style]="radioTypesEnum.button"
                                [icon]="'fa-objects-align-right'"
                                (onClick)="setStyle(fontAlignmentEnum.right, 'alignment')"
                                [hiddenLabel]="'PageBuilder.formField.tooltip.alignRight' | localize"
                            ></agpr-radio>
                        </div>
                        <div role="radiogroup" [attr.aria-label]="'PageBuilder.formField.tooltip.linkLayout' | localize" style="display: flex;">
                            <agpr-radio
                                class="agpr-linkStyleField-button agpr-linkStyleField-linkLayoutButton"
                                [id]="id + '.verticalButton'"
                                name="layout-{{id}}"
                                [value]="linkLayoutOptionEnum.vertical"
                                [(ngModel)]="value.layoutOption"
                                [iconTooltip]="'PageBuilder.formField.tooltip.linkVertical'"
                                tooltipPosition="top"
                                [style]="radioTypesEnum.button"
                                [icon]="'fa-arrows-up-down'"
                                (onClick)="setStyle(linkLayoutOptionEnum.vertical, 'layoutOption')"
                                [hiddenLabel]="'PageBuilder.formField.tooltip.linkVertical' | localize"
                            ></agpr-radio>
                            <agpr-radio
                                class="agpr-linkStyleField-button"
                                [id]="id + '.horizontalButton'"
                                name="layout-{{id}}"
                                [value]="linkLayoutOptionEnum.horizontal"
                                [(ngModel)]="value.layoutOption"
                                [iconTooltip]="'PageBuilder.formField.tooltip.linkHorizontal'"
                                tooltipPosition="top"
                                [style]="radioTypesEnum.button"
                                [icon]="'fa-arrows-left-right'"
                                (onClick)="setStyle(linkLayoutOptionEnum.horizontal, 'layoutOption')"
                                [hiddenLabel]="'PageBuilder.formField.tooltip.linkHorizontal' | localize"
                            ></agpr-radio>
                        </div>
                    </div>
                </div>
                <div class="agpr-linkStyleField-row">
                    <agpr-color-picker-field
                        class="agpr-linkStyleField-linkBackgroundColor"
                        [id]="id + '.backgroundColorPicker'"
                        [field]="colorPickerField"
                        [value]="value.color"
                        (changes)="setStyle($event, colorPickerField.property)"
                    ></agpr-color-picker-field>
                </div>
            </div>
            <div role="group" [attr.aria-label]="'PageBuilder.formField.styles.icon' | localize">
                <div class="agpr-linkStyleField-header" [class.agpr-linkStyleField-header--textPrimary]="textPrimaryLabel">
                    {{ 'PageBuilder.formField.styles.icon' | localize}}
                </div>
                <div class="agpr-linkStyleField-row">
                    <agpr-dropdown-field
                        class="agpr-linkStyleField-displayDropdown"
                        [id]="id + '.iconSizeDropdown'"
                        [value]="value.iconSize"
                        [field]="iconSizeDropDownField"
                        (changes)="setStyle($event, 'iconSize')"
                    >
                    </agpr-dropdown-field>
                    <agpr-dropdown-field
                        class="agpr-linkStyleField-displayDropdown"
                        [id]="id + '.iconColorDropdown'"
                        [value]="value.iconColor"
                        [field]="iconColorDropDownField"
                        (changes)="setStyle($event, 'iconColor'); onIconColorChange($event)"
                    >
                    </agpr-dropdown-field>
                </div>
            </div>
            <div role="group" [attr.aria-label]="'PageBuilder.formField.styles.iconBackground' | localize">
                <div class="agpr-linkStyleField-header" [class.agpr-linkStyleField-header--textPrimary]="textPrimaryLabel">
                    {{ 'PageBuilder.formField.styles.iconBackground' | localize}}
                </div>
                <agpr-color-picker-field
                    class="agpr-linkStyleField-iconBackground"
                    [id]="id + '.icon_backgroundColorPicker'"
                    [field]="iconBackgroundColorField"
                    [value]="value.color"
                    (changes)="setStyle($event, iconBackgroundColorField.property)"
                ></agpr-color-picker-field>

                <span [id]="id + '_iconBackground_cornerRadius_label'" class="u-srOnly">{{'PageBuilder.formField.link.backgroundCornerLabel' | localize}}</span>
                <agpr-slider-input
                    [(ngModel)]="value.iconShape"
                    class="agpr-linkStyleField-slider agpr-linkStyleField-iconShape"
                    [showValue]="false"
                    [min]="0"
                    [max]="28"
                    [step]="2"
                    [leftIcon]="'agpr-i-squared'"
                    leftTooltip="PageBuilder.formField.tooltip.sharpCorner"
                    [rightIcon]="'agpr-i-rounded'"
                    rightTooltip="PageBuilder.formField.tooltip.roundedCorner"
                    [ariaValueText]="value.iconShape + 'px'"
                    (ngModelChange)="setStyle($event, 'iconShape')"
                    [ariaLabelledBy]="id + '_iconBackground_cornerRadius_label'"
                ></agpr-slider-input>
            </div>
            <div role="group" [attr.aria-label]="'PageBuilder.formField.styles.linkText' | localize">
                <div class="agpr-linkStyleField-header" [class.agpr-linkStyleField-header--textPrimary]="textPrimaryLabel">
                    {{ 'PageBuilder.formField.styles.linkText' | localize}}
                </div>
                <div class="agpr-linkStyleField-row">
                    <agpr-dropdown-field
                        class="agpr-linkStyleField-font"
                        [id]="id + '.fontFamilyDropdown'"
                        [value]="value.fontFamily"
                        [field]="fontFamilyField"
                        appendTo="body"
                        (changes)="setStyle($event, fontFamilyField.property)"
                        [pTooltip]="'PageBuilder.formField.tooltip.fontName' | localize"
                    >
                    </agpr-dropdown-field>
                    <agpr-checkbox
                        class="agpr-linkStyleField-button"
                        [id]="id + '.bold'"
                        [(ngModel)]="value.bold"
                        [tooltip]="'PageBuilder.formField.tooltip.bold'"
                        [binary]="true"
                        [style]="checkboxTypesEnum.button"
                        [icon]="'agpr-i-font-bold'"
                        (onChange)="setStyle($event, 'bold')"
                    >
                    </agpr-checkbox>
                    <agpr-checkbox
                        class="agpr-linkStyleField-button"
                        [id]="id + '.italics'"
                        [(ngModel)]="value.italics"
                        [tooltip]="'PageBuilder.formField.tooltip.italics'"
                        [binary]="true"
                        [style]="checkboxTypesEnum.button"
                        [icon]="'agpr-i-font-italic'"
                        (onChange)="setStyle($event, 'italics')"
                    >
                    </agpr-checkbox>
                    <agpr-checkbox
                        class="agpr-linkStyleField-button"
                        [id]="id + '.underlined'"
                        [(ngModel)]="value.underlined"
                        [tooltip]="'PageBuilder.formField.tooltip.underline'"
                        [binary]="true"
                        [style]="checkboxTypesEnum.button"
                        [icon]="'agpr-i-font-underline'"
                        (onChange)="setStyle($event, 'underlined')"
                    >
                    </agpr-checkbox>
                </div>
                <div class="agpr-linkStyleField-row  agpr-linkStyleField-row--wrap">
                    <div
                        [pTooltip]="'PageBuilder.formField.tooltip.fontSize' | localize"
                        class="agpr-linkStyleField-fontSize"
                    >
                        <div class="agpr-linkStyleField-fontSizeIcon">
                            <i
                                class="agpr-i-font-size"
                                aria-hidden="true"
                            ></i>
                        </div>
                        <agpr-dropdown-field
                            class="agpr-linkStyleField-fontSizeDropdown"
                            [id]="id + '.fontSizeDropdown'"
                            [value]="value.fontSize"
                            [field]="fontSizeField"
                            (changes)="setStyle($event, fontSizeField.property)"
                        >
                        </agpr-dropdown-field>
                    </div>
                    <agpr-color-picker-field
                        class="agpr-linkStyleField-fontColor"
                        [id]="id + '.textColorPicker'"
                        [field]="fontColorPickerField"
                        [value]="value.color"
                        (changes)="setStyle($event, fontColorPickerField.property)"
                    ></agpr-color-picker-field>

                </div>

            </div>
            <agpr-block-padding
                [id]="id + '_padding'"
                [(padding)]="value.padding"
                (paddingChanged)="setStyle($event, 'padding')"
            ></agpr-block-padding>
        </div>
        <div
            *ngIf="value.template"
        >
            <agpr-message [severity]="messageSeverityEnum.info">
                {{ "PageBuilder.styles.expertStyleAppliedPreMessage" | localize }}
                <span style="font-weight: bold">
                {{ field.label | localize }}
            </span>
                {{ "PageBuilder.styles.expertStyleAppliedPostMessage" | localize }}
            </agpr-message>
        </div>
    </div>
</div>
